import * as React from "react";
import BetGeniusStats from "../../BetGeniusStats";
import { SportEvent } from "./model";

const styles = require("./styles.scss"); // tslint:disable-line no-var-requires

interface Props {
    sportEvent: SportEvent;
    lang: string;
}

function TennisLive({ sportEvent, lang }: Props): JSX.Element | null {
    if (!sportEvent) {
        return null;
    }

    return sportEvent.betGeniusId ? (
        <div className={styles.scorecenter}>
            <BetGeniusStats sportEvent={sportEvent} lang={lang} />
        </div>
    ) : null;
}

export default TennisLive;
